import { render } from "./MaterialCheckboxField.vue?vue&type=template&id=a8beb6fa"
import script from "./MaterialCheckboxField.vue?vue&type=script&lang=js"
export * from "./MaterialCheckboxField.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__